import $ from "jquery";
import 'slick-carousel';

export const tutorialsSlider = () => {
    $('.tutorial-slider').slick({
        centerMode: true,
        centerPadding: '12px',
        slidesToShow: 3,
        variableWidth: true,
    });

    let filtered = false;

    $('.js-filter').on('click', function(){
        if (filtered === false) {
            $('.filtering').slick('slickFilter',':even');
            $(this).text('Unfilter Slides');
            filtered = true;
        } else {
            $('.filtering').slick('slickUnfilter');
            $(this).text('Filter Slides');
            filtered = false;
        }
    });


    // let swiper = new Swiper(".tutorial-slider", {
    //     slidesPerView: 4,
    //     spaceBetween: 30,
    //     loop: true,
    //     pagination: {
    //         el: ".swiper-pagination",
    //         clickable: true
    //     }
    // });
};
